<template>
    <svg width="14"
         height="14"
         viewBox="0 0 14 14"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M2.91663 7.00016L11.0833 7.00016M11.0833 7.00016L6.99996 11.0835M11.0833 7.00016L6.99996 2.91683"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
    </svg>
</template>

<script>
export default {
    name: 'IconArrowRight'
};
</script>
